const isMobile = window.innerWidth <= 767;

function openTab(product) {
  const tabContents = document.getElementsByClassName('tab-content');
  for (const content of tabContents) {
    content.style.display = 'none';
  }

  const tabButtons = document.getElementsByClassName('tab-button');
  for (const button of tabButtons) {
    button.classList.remove('active');
  }

  const selectedTab = document.querySelector(`#${product}`);
  selectedTab.style.display = 'block';
  event.currentTarget.classList.add('active');
}

function openDefaultTab() {
  const defaultTab = document.querySelector('.tab-button-1');
  if (defaultTab) {
    defaultTab.click();
  }
}

function openTabContent(product) {
  const tabContent = document.querySelector(`#${product}`);
  if (!tabContent) {
    console.error('Tab content not found.');
    return;
  }


  if (isMobile) {
    openMobilePopup(tabContent.innerHTML);
  } else {
    openTab(product);
  }
}

function openMobilePopup(content) {
  const mobilePopupContainer = document.querySelector('.mobile-popup-container');
  const mobilePopupContent = document.querySelector('.mobile-popup-content');

  if (mobilePopupContainer && mobilePopupContent) {
    mobilePopupContent.innerHTML = content;
    mobilePopupContainer.style.display = 'block';

    document.body.classList.add('mobile-popup-open');
    document.body.style.overflow = 'hidden';

  }
}

function closeMobilePopup() {
  const mobilePopupContainer = document.querySelector('.mobile-popup-container');

  if (mobilePopupContainer) {
    mobilePopupContainer.style.display = 'none';
    document.body.classList.remove('mobile-popup-open');
    document.body.style.overflow = 'auto';

  }
}

window.addEventListener('DOMContentLoaded', function () {
  if (!isMobile) openDefaultTab();
});
